export default "__VITE_ASSET__DG2TEr8c__"